import logo from '../images/logo.webp';
import { useState } from "react";
import { FaBars } from "react-icons/fa";
import { useEffect } from "react";

export default function Navbar() {
    const [isOpen, setIsOpen] = useState(false);
    const toggleMenu = ()=>{
        setIsOpen(!isOpen)
    };
    
    useEffect(() => {
  const blockEvent = (e) => {
    e.preventDefault();
    e.stopPropagation();
    return false;
  };

  const blockKeys = (e) => {
    // Ctrl + Shift + I / J / C
    if (
      (e.ctrlKey && e.shiftKey && ["I", "J", "C"].includes(e.key)) ||
      // Ctrl + U
      (e.ctrlKey && e.key.toLowerCase() === "u") ||
      // F12
      e.key === "F12"
    ) {
      e.preventDefault();
      e.stopPropagation();
      return false;
    }
  };

  // Mouse / selection / copy
  document.addEventListener("contextmenu", blockEvent, true);
  document.addEventListener("copy", blockEvent, true);
  document.addEventListener("cut", blockEvent, true);
  document.addEventListener("selectstart", blockEvent, true);
  document.addEventListener("mousedown", blockEvent, true);

  // Keyboard (DevTools / View source)
  document.addEventListener("keydown", blockKeys, true);

  // Mobile
  document.body.style.webkitTouchCallout = "none";
  document.body.style.userSelect = "none";

  return () => {
    document.removeEventListener("contextmenu", blockEvent, true);
    document.removeEventListener("copy", blockEvent, true);
    document.removeEventListener("cut", blockEvent, true);
    document.removeEventListener("selectstart", blockEvent, true);
    document.removeEventListener("mousedown", blockEvent, true);
    document.removeEventListener("keydown", blockKeys, true);
  };
}, []);

  return (
    <>
      <header id="up-click">
            <div className="container flex-row justify-between">
                <aside>
                    <a href="/">
                        <img src={logo} height="60" width="300" alt="Riya Dubey Escorts Agency Banner" title="Riya Dubey Escorts Agency Banner" />
                    </a>
                </aside>
                <nav>
                    <div className="rd-icon" onClick={toggleMenu}>
                        <FaBars />
                    </div>
                    <ul className={isOpen ? "nav-link active" : "flex-row nav-link" }>
                        <li><a href="/">Home</a></li>
                        <li><a href="/#about-us">About Us</a></li>
                        <li><a href="/#profile">Profile</a></li>
                        <li><a href="/#categories">Categories</a></li>
                        <li><a href="/#location">Location</a></li>
                        <li><a href="/#rates">Rates</a></li>
                        <li><a href="/#contact-us">Contact Us</a></li>
                    </ul>
                </nav>
            </div>
        </header>
    </>
  )
}
